import MainLayout from "../layouts/MainLayout";
import AboutHero from "../components/AboutHero";
import MissionVision from "../components/MissionVision";
import CoreValues from "../components/CoreValues";

export default function WhoWeAre() {
  return (
    <MainLayout>
      <AboutHero />
      <MissionVision />
      <CoreValues />
    </MainLayout>
  );
}